import React from 'react';
import ReactDOM from 'react-dom';
import { FaTimes, FaArrowRight, FaCheck } from 'react-icons/fa';
import './TutorialModal.css';

const TutorialModal = ({ onClose, currentStep, onNext, onPrevious, onFinish }) => {
  const steps = [
    {
      id: 1,
      title: '🎨 เลือกวัตถุที่ต้องการ',
      description: 'คลิกที่ Sidebar ด้านซ้ายเพื่อเลือก Text, Image, QR Code หรือวัตถุอื่นๆ',
      image: '📌',
      tip: 'คุณสามารถ "ลากวาง" วัตถุลงบน Canvas ได้โดยตรง',
    },
    {
      id: 2,
      title: '🖱️ วางลงบน Canvas',
      description: 'คลิกหรือลากวัตถุลงในพื้นที่ตรงกลาง (Canvas) จากนั้นปรับตำแหน่งตามต้องการ',
      image: '🎯',
      tip: 'ใช้ Grid และ Snap เพื่อจัดวางให้เป็นระเบียบ',
    },
    {
      id: 3,
      title: '⚙️ ปรับแต่งคุณสมบัติ',
      description: 'คลิกที่วัตถุที่วาง จากนั้นแก้ไขสี ฟอนต์ ขนาด และคุณสมบัติอื่นๆ ที่ Properties Panel ด้านขวา',
      image: '🎛️',
      tip: 'กดคู่ที่ Text เพื่อแก้ไขข้อความได้โดยตรง',
    },
    {
      id: 4,
      title: '💾 บันทึกและส่งออก',
      description: 'เมื่อออกแบบเสร็จแล้ว ให้คลิกปุ่ม "Export" ที่ Header เพื่อดาวน์โหลดเป็น PDF หรือ PNG',
      image: '✨',
      tip: 'รองรับขนาด A3, A4, A5 ทั้งแนวตั้งและแนวนอน',
    },
  ];

  const currentStepData = steps[currentStep];
  const isLastStep = currentStep === steps.length - 1;
  const isFirstStep = currentStep === 0;

  return ReactDOM.createPortal(
    <div className="tutorial-modal-overlay" onClick={onClose}>
      <div className="tutorial-modal" onClick={e => e.stopPropagation()}>
        <button className="tutorial-close-btn" onClick={onClose} title="ปิด">
          <FaTimes />
        </button>

        <div className="tutorial-progress">
          <div className="progress-bar-track">
            <div 
              className="progress-bar-fill" 
              style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }}
            />
          </div>
          <div className="progress-text">
            ขั้นตอนที่ {currentStep + 1} จาก {steps.length}
          </div>
        </div>

        <div className="tutorial-content">
          <div className="tutorial-step-number">
            Step {currentStep + 1}
          </div>
          
          <div className="tutorial-image">
            <div className="tutorial-emoji">{currentStepData.image}</div>
          </div>

          <h2 className="tutorial-title">{currentStepData.title}</h2>
          <p className="tutorial-description">{currentStepData.description}</p>
          
          <div className="tutorial-tip">
            <span className="tip-icon">💡</span>
            <span className="tip-text">{currentStepData.tip}</span>
          </div>
        </div>

        <div className="tutorial-steps-indicator">
          {steps.map((step, index) => (
            <div 
              key={step.id} 
              className={`step-dot ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
              onClick={() => {
                if (index !== currentStep) {
                  // Allow jumping to any step
                  const diff = index - currentStep;
                  if (diff > 0) {
                    for (let i = 0; i < diff; i++) onNext();
                  } else {
                    for (let i = 0; i < Math.abs(diff); i++) onPrevious();
                  }
                }
              }}
            >
              {index < currentStep ? <FaCheck /> : index + 1}
            </div>
          ))}
        </div>

        <div className="tutorial-actions">
          <button 
            className="btn-tutorial-skip" 
            onClick={onClose}
          >
            ข้าม
          </button>
          
          <div className="tutorial-nav-buttons">
            {!isFirstStep && (
              <button 
                className="btn-tutorial-prev" 
                onClick={onPrevious}
              >
                ก่อนหน้า
              </button>
            )}
            
            {isLastStep ? (
              <button 
                className="btn-tutorial-finish" 
                onClick={onFinish}
              >
                <FaCheck /> เสร็จสิ้น
              </button>
            ) : (
              <button 
                className="btn-tutorial-next" 
                onClick={onNext}
              >
                ถัดไป <FaArrowRight />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TutorialModal;
